module.exports = __webpack_public_path__ + "static/media/logo.62521973.svg";